import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import speedIcon from '../../components/atoms/data/speed-icon.svg';
import rewindicon from '../../components/atoms/data/before-5-icon-1.svg';
import forwardicon from '../../components/atoms/data/after-5-icon.svg';



class Audio extends Component {
    constructor(props) {
        super(props);

        this.timer = null;
        this.seeking = false;

        this.refAudio = React.createRef();
        this.refSeekbar = React.createRef();
        this.refSeekbarButton = React.createRef();
        this.state = {
            duration: 0,
            current: 0,
            play: false,
            playbackRate: this.props.playbackRate ? this.props.playbackRate : 1,
            repeat: false,
            setting: false,
            startTime: 0,
            drag: false,
        }
    }

    getDevice() {
        var ua = navigator.userAgent;
        if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
            return 'sp';
        } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
            return 'tab';
        } else {
            return 'other';
        }
    }

    componentDidMount() {
        this.setState({
            duration: 0,
            current: 0
        });
        this.refAudio.current.playbackRate = this.state.playbackRate;
        this.refAudio.current.addEventListener("durationchange", (e) => {
            if (e.target.src.indexOf("audio/x-m4a") !== -1 || e.target.src.indexOf("audio/mpeg") !== -1) {
                if (e.target.duration !== Infinity) {
                    this.setState({
                    duration: e.target.duration,
                });
                this.refAudio.current.removeEventListener("durationchange", (e) => {});
                }
            } else {
                this.refAudio.current.removeEventListener("durationchange", (e) => {});
            }
        }, false)

        if (this.refSeekbarButton.current) {
            if (this.getDevice() === "other") {
                this.refSeekbarButton.current.addEventListener('mousedown', this.onMouseDownSeekbutton, { passive: false });
                this.refSeekbarButton.current.addEventListener('mousemove', this.onMouseMoveSeekbutton, { passive: false });
                this.refSeekbarButton.current.addEventListener('mouseleave', this.onMouseUpSeekbutton, { passive: false });
                this.refSeekbarButton.current.addEventListener('mouseup', this.onMouseUpSeekbutton, { passive: false });
            } else {
                this.refSeekbarButton.current.addEventListener('touchstart', this.onTouchStartSeekbutton, { passive: false });
                this.refSeekbarButton.current.addEventListener('touchmove', this.onTouchMoveSeekbutton, { passive: false });
                this.refSeekbarButton.current.addEventListener('touchend', this.onTouchEndSeekbutton, { passive: false });
            }
        }
    }
    setWebm = () => {
        this.refAudio.current.currentTime = 24 * 60 * 60;
    }

    TimeUpdate = (e) => {
        this.setState({
            current: this.refAudio.current.currentTime,
        });
    }
    Ended = (e) => {
        if (this.state.repeat) {
            this.refAudio.current.currentTime = this.state.startTime;
            this.refAudio.current.play();
            this.setState({
                current: 0
            });
        } else {
            this.refAudio.current.currentTime = this.state.startTime;
            this.Stop();
            if (this.props.onEnded) {
                this.props.onEnded();
            }
        }
    }
    onClickPlay = (e) => {
        if (this.state.play) {
            this.Stop();
        } else {
            this.Play();
        }
    }
    Play() {
        this.setState({
            duration: this.refAudio.current.duration,
        });
        if (this.refAudio.current.currentTime < this.state.startTime) {
            this.refAudio.current.currentTime = this.state.startTime;
        }
        this.refAudio.current.play();
        this.setState({ play: true });
        if (this.props.onPlay) {
            this.props.onPlay();
        }
    }
    Stop() {
        this.refAudio.current.pause();
        this.setState({ play: false });
        if (this.props.onStop) {
            this.props.onStop();
        }
    }

    onTouchStartSeekbutton = (e) => {
        if (this.getDevice() === "other") return;
        e.preventDefault();
        e.stopPropagation();
        if (this.state.duration) {
            if (this.state.play) {
                this.refAudio.current.pause();
            }
            let pos = (e.touches[0].clientX - this.refSeekbar.current.getBoundingClientRect().x) / this.refSeekbar.current.getBoundingClientRect().width;
            this.refAudio.current.currentTime = this.state.duration * pos;
        }
        this.setState({ drag: true });
    }
    onMouseDownSeekbutton = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.state.duration) {
            if (this.state.play) {
                this.refAudio.current.pause();
            }
            let pos = (e.clientX - this.refSeekbar.current.getBoundingClientRect().x) / this.refSeekbar.current.getBoundingClientRect().width;
            this.refAudio.current.currentTime = this.state.duration * pos;
        }
        this.setState({ drag: true });
    }
    onTouchEndSeekbutton = (e) => {
        if (this.getDevice() === "other") return;
        e.preventDefault();
        e.stopPropagation();
        if (this.state.duration) {
            if (this.state.play) {
                this.refAudio.current.play();
            }
        }
        this.setState({ drag: false });
    }
    onMouseUpSeekbutton = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.state.duration) {
            if (this.state.play) {
                this.refAudio.current.play();
            }
        }
        this.setState({ drag: false });
    }
    onTouchMoveSeekbutton = (e) => {
        if (this.getDevice() === "other") return;
        e.preventDefault();
        e.stopPropagation();
        if (this.state.duration) {
            let pos = (e.touches[0].clientX - this.refSeekbar.current.getBoundingClientRect().x) / this.refSeekbar.current.getBoundingClientRect().width;
            this.refAudio.current.currentTime = this.state.duration * pos;
        }
    }
    onMouseMoveSeekbutton = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.state.duration && this.state.drag) {
            let pos = (e.clientX - this.refSeekbar.current.getBoundingClientRect().x) / this.refSeekbar.current.getBoundingClientRect().width;
            this.refAudio.current.currentTime = this.state.duration * pos;
        }
    }

    onClickRepeatbutton = (e) => {
        if (this.state.repeat) {
            this.setState({ repeat: false });
        } else {
            this.setState({ repeat: true });
        }
    }

    onClickSettingbutton = (e) => {
        if (this.state.setting) {
            this.setState({ setting: false });
        } else {
            this.setState({ setting: true });
        }
    }

    onClickTimeControl = (e) => {
        if (this.state.duration) {
            this.setState({ startTime: this.refAudio.current.currentTime });
        }
    }

    set(id) {
        this.refAudio.current.pause();

        this.refAudio.current.src = this.props.src[id];
        this.refAudio.current.load();
    }

    getTimeText(time) {
        let M = Math.floor(time / 60);
        let S = time % 60;
        S = ('0' + S).slice(-2);
        const res = M + ':' + S;

        return res;
    }

    onClickSelector = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const rate = Number(e.target.innerText);
        this.refAudio.current.playbackRate = rate;
        this.setState({ 
            playbackRate: rate, 
            setting: false 
        });

        if (this.props.onChangePlaybackRate) {
            this.props.onChangePlaybackRate(rate);
        }
    }
    createSpeedSelector() {
        let speed = 0.5;
        let selector = [];
        while (1) {
            let text = (speed + '.0').slice(0, 3);
            let style = speed === this.state.playbackRate ? { backgroundColor: "#f9f9f9" } : { background: "transparent" };
            selector.push(
                <Speed key={speed} style={style} onClick={this.onClickSelector}>{text}</Speed>
            )
            speed += 0.1;
            speed = Math.round(speed * 10) / 10;
            if (speed > 2.0) {
                break;
            }
        }
        return selector;
    }

    onRewind = (e) => {
        this.refAudio.current.currentTime -= 5;
    }

    onForward = (e) => {
        this.refAudio.current.currentTime += 5;
    }

    render() {
        const current = Math.floor(this.state.current);
        const duration = Math.floor(this.state.duration);
        const cTime = this.getTimeText(current);
        const dTime = this.getTimeText(duration);

        let posBar = duration ? -(100 - (current / duration * 100)) + "%" : "-100%";
        let posButton = (current / duration * 100) + "%";

        let playIcon = this.state.play ? <i className="fas fa-equals fa-rotate-90" /> : <i className="far fa-play-circle" />;
        let audioSrc = this.props.src && this.props.play >= 0 ? this.props.src[this.props.play] : '';
        let rewindIcon = (this.props.rewindDisplay) ? <img src={rewindicon} alt="img" width="24px" height="24px" /> : '';
        let forwardIcon = (this.props.forwardDisplay) ? <img src={forwardicon} alt="img" width="24px" height="24px" /> : '';
        let repeatIcon = (this.props.repeatDisplay) ? <i className="fas fa-sync" /> : '';
        const speed = this.state.playbackRate.toFixed(1);
        return (
            <Player name="player">
                <ControllerWrap>
                    <PlayerController>
                        <SeekBarWrap>
                            <SeekBar ref={this.refSeekbarButton}>
                                <SeekBarBack ref={this.refSeekbar} />
                                <SeekBarFront left={posBar} />
                            </SeekBar>
                            <SeekBarButton left={posButton} type="button" />
                        </SeekBarWrap>
                        <span>{cTime} / {dTime}</span>
                    </PlayerController>
                    <ControllerOptions>
                        <GroupGrid>
                            <SpeedControlWrap>
                                <SpeedControl onClick={this.onClickSettingbutton}>
                                    <SpeedIcon>
                                        <img src={speedIcon} alt="img" width="20px" height="20px" />
                                    </SpeedIcon>
                                    <TextField>
                                        ×{speed}
                                    </TextField>
                                </SpeedControl>
                                <Setting setting={this.state.setting}>
                                    <Selector>{this.createSpeedSelector()}</Selector>
                                </Setting>
                            </SpeedControlWrap>

                            <Rewind type="button" onClick={this.onRewind}>
                                {rewindIcon}
                            </Rewind>
                            <PlayIcon type="button" onClick={this.onClickPlay}>
                                {playIcon}
                            </PlayIcon>
                            <Forward type="button" onClick={this.onForward}>
                                {forwardIcon}
                            </Forward>

                            <RepeatIcon repeat={this.state.repeat} onClick={this.onClickRepeatbutton}>
                                {repeatIcon}
                            </RepeatIcon>
                        </GroupGrid>
                    </ControllerOptions>
                </ControllerWrap>
                <audio ref={this.refAudio} autobuffer="true" id="audio" src={audioSrc} onTimeUpdate={this.TimeUpdate} onEnded={this.Ended} />
            </Player>
        );
    }
}

export { Audio };

Audio.propTypes = {
    playbackRate: PropTypes.number.isRequired,
    src: PropTypes.array.isRequired,
    play: PropTypes.number.isRequired,
    onEnded: PropTypes.func,
    onPlay: PropTypes.func,
    onStop: PropTypes.func,
    onChangePlaybackRate: PropTypes.func,
};

const Player = styled.div`
    width: 350px;
    height: 69px;
    position: relative;
    border-top: 1px solid #ddd;`;

const ControllerWrap = styled.div`
`;

const PlayerController = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 25px;
    color: #b9b9b9;
    background-color: transparent;
`;
const SeekBarWrap = styled.div`
    position: relative;
    width: 250px;
    height: 100%;
`;
const SeekBar = styled.div`
    position: relative;
    width: 250px;
    height: 100%;
    overflow: hidden;
`;
const SeekBarBack = styled.div`
    position: absolute;
    background-color: #b9b9b9;
    width: 100%;
    height: 5px;
    top: 50%;
    pointer-events: none;
    transform: translateY(-50%);
`;
const SeekBarFront = styled.div`
    position: absolute;
    background-color: #555555;
    width: 100%;
    height: 5px;
    top: 50%;
    left: ${props => (props.left ? props.left : '-100%')};
    pointer-events: none;
    transform: translateY(-50%);
`;
const SeekBarButton = styled.div`
    position: absolute;
    background-color: #b9b9b9;
    border: 1px solid #999999;
    border-radius: 2px;
    width: 10px;
    height: 17px;
    top: 50%;
    left: ${props => (props.left ? props.left : '0%')};
    pointer-events: none;
    transform: translateY(-50%);
`;

const ControllerOptions = styled.div`
    display: flex;
    height: 50px;
`;

const GroupGrid = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 30% 10% 1fr 10% 30%;
    place-items: center;   
`;
const SpeedControlWrap = styled.div`
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #eeeeee;
    border-radius: 20px;
    padding: 3px 1px;
    width: 80px;
    font-size: 18px;
    margin:auto 0px;

    grid-column-start: 1;
    grid-column-end: 1;
`;
const SpeedControl = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
`;
const SpeedIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    color: #0077FF;
    font-size:18px;
`;

const Rewind = styled.div`
    grid-column-start: 2;
    grid-column-end: 2;
`;

const PlayIcon = styled.div`
    background-color: transparent;
    color: #0077FF;
    font-size: 40px;

    grid-column-start: 3;
    grid-column-end: 3;
`;

const Forward = styled.div`
    grid-column-start: 4;
    grid-column-end: 4;
`;

const RepeatIcon = styled.div`
    color: ${props => (props.repeat ? '#0077FF' : '#dddddd')};
    font-size: 24px;
    transition-duration: 0.2s;
    transform: scaleX(-1);
    grid-column-start: 5;
    grid-column-end: 5;
`;

const Setting = styled.div`
    position: absolute;
    top: -205px;
    margin-top: ${props => (props.setting ? '0' : '5px')};
    left: 50%;
    transform: translateX(-50%);
    opacity: ${props => (props.setting ? '1' : '0')};
    transition-duration: 0.2s;

    display: flex;
    justify-content: space-around;
    width: 90px;
    pointer-events: ${props => (props.setting ? '' : 'none')};
`;

const TextField = styled.div`
    margin-bottom: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 20px;
`;

const Speed = styled.div`
    text-align: center;
`;
const Selector = styled.div`
    background-color: #eeeeee;
    border-radius: 5px;
    min-width: 100px;
    height: 200px;
    overflow: auto;
    box-shadow: 0 0 6px rgba(0,0,0,0.3);
`;